export const SET_FORM_PHONE_NUMBER_REQUEST = 'SET_FORM_PHONE_NUMBER_REQUEST';
export const SET_FORM_PIN_NUMBER_REQUEST = 'SET_FORM_PIN_NUMBER_REQUEST';
export const SET_URL_FORM_TO_SUBSCRIPTION = 'SET_URL_FORM_TO_SUBSCRIPTION';

export const VALID_INPUT_PHONE = 'VALID_INPUT_PHONE';
export const VALID_CHECKBOX = 'VALID_CHECKBOX';
export const VALID_EMAIL = 'VALID_EMAIL';
export const VALID_INPUT_PIN = 'VALID_INPUT_PIN';

export const GET_PIN_FOR_AUTHORIZE = 'GET_PIN_FOR_AUTHORIZE';
export const GET_PIN_FOR_AUTHORIZE_LOADED = 'GET_PIN_FOR_AUTHORIZE_LOADED';
export const GET_PIN_FOR_AUTHORIZE_ERROR = 'GET_PIN_FOR_AUTHORIZE_FAILED';

export const GET_CODE_OF_AUTHORIZE = 'GET_CODE_OF_AUTHORIZE';
export const GET_CODE_OF_AUTHORIZE_LOADED = 'GET_CODE_OF_AUTHORIZE_LOADED';
export const GET_CODE_OF_AUTHORIZE_ERROR = 'GET_PIN_FOR_AUTHORIZE_FAILED';

export const GO_TO_URL_TO_SUBSCRIPTION = 'GO_TO_URL_TO_SUBSCRIPTION';

export const EDIT_PHONE_NUMBER = 'EDIT_PHONE_NUMBER';

export const COUNTRY_CODE = '55';

export const SHOW_MESSAGE_WITHOUT_SUBSCRIPTION = 'SHOW_MESSAGE_WITHOUT_SUBSCRIPTION';

/* ===========================================================
 =            Constants for Error Message Handler            =
 ===========================================================*/
export const MSG_PHONE_NUMBER_EMPTY = 'Digite um número para avançar';
// eslint-disable-next-line
export const MSG_PHONE_NUMBER_INCONPLETE = 'Número de celular inválido!';
export const MSG_PHONE_NUMBER_INVALID_TO_SEND_PIN = 'Número de celular inválido para enviar um PIN';
export const MSG_PIN_NUMBER_EMPTY = 'Digite um PIN para avançar';
export const MSG_PIN_INVALID = 'O PIN ou o número de celular é inválido';
export const MSG_PIN_INCOMPLETE = 'O PIN deve ter 4 números';
export const MSG_PIN_LIMIT_REACHED = 'Limite de PIN alcançado, solicite um novo PIN';
export const MSG_NUMBER_WIHTOUT_SUBSCRIPTION = 'Você não é assinante do serviço.';
export const MSG_RECAPTCHA_DATA_EMPTY = 'Falha na validação do Recaptcha.';

/* =====  End of Constants for Error Message Handler  ======*/



// WEBPACK FOOTER //
// ./src/containers/ManualAccessPage/constants.js